import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'
import defaultProfile from './asset/default_profile.svg'
import profile from './asset/profile.svg'
import info from './asset/info.svg'
import contact from './asset/contact.svg'
// import payment from "./asset/payment.svg"
import ticket from './asset/ticket.svg'
import event from './asset/event.svg'
import exam from './asset/exam.svg'
import premium from './asset/premium.svg'
import qrcode from 'shared/assets/qrcode-scan.svg'

import ProfileModal from './ui/ProfileModal'
import NicknameModal from './ui/NicknameModal'
import ContactModal from './ui/ContactModal'
import WithdrawConfirmModal from './ui/WithdrawConfirmModal'
import QRModal from './ui/QRModal'

import FooterPage from 'widget/FooterPage'

import useGetAccount from 'entity/account/useGetAccount'

import ControlButton from 'widget/ControlButton'
import DefaultButton from 'shared/ui/DefaultButton'
import useLoginCookie from 'shared/model/useLoginCookie'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import convertTier from 'shared/lib/convertTier'
import convertMoney from 'shared/lib/convertMoney'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import convertTierIcon from 'shared/lib/convertTierIcon'

const Mypage = () => {
	const navigate = useNavigate()

	const [getAccount] = useGetAccount()

	const [isProfileModalShow, setIsProfileModalShow] = useState(false)
	const [isNicknameModalShow, setIsNicknameModalShow] = useState(false)
	const [isContactModalShow, setIsContactModalShow] = useState(false)
	const [isWithdrawModalShow, setIsWithdrawModalShow] = useState(false)
	const [isQRModalShow, setIsQRModalShow] = useState(false)
	const [isTierIconLoaded, setIsTierIconLoaded] = useState(false)
	const [, , deleteLoginCookie] = useLoginCookie()

	const [, setAlert] = useAlertModalAtom()
	const [, setConfirm] = useConfirmModalAtom()

	const withdrawEvent = () => {
		setConfirm(
			'CAUTION !\n\n모든 기록이 소실됩니다.\n정말 탈퇴하시겠습니까?',
			() => () => setIsWithdrawModalShow(true)
		)
	}

	const logoutEvent = () => {
		setConfirm('정말 로그아웃 하시겠습니까?', () => deleteLoginCookie)
	}

	const myInfo = {
		qualifications: getAccount?.data?.qualifications,
		score: getAccount?.data?.score
			? convertMoney(getAccount?.data?.score)
			: '0',
		tier: convertTier(getAccount?.data?.score),
		tierIcon: convertTierIcon(getAccount?.data?.score),
	}

	const infoList = [
		{
			icon: profile,
			label: '프로필 이미지 수정',
			clickEvent: () => setIsProfileModalShow(true),
		},
		{
			icon: info,
			label: '정보 수정',
			clickEvent: () => setIsNicknameModalShow(true),
		},
		{
			icon: contact,
			label: '연락처 수정',
			clickEvent: () => setIsContactModalShow(true),
		},
		{
			icon: qrcode,
			label: '내 QR 코드',
			clickEvent: () => setIsQRModalShow(true),
		},
	]

	// const premiumData = {
	//     "icon": payment,
	//     "label": "프리미엄 계정 신청하기",
	//     "clickEvent": () => navigate(`/payment/premium`)
	// }

	const recordList = [
		{
			icon: ticket,
			label: '보유 티켓',
			clickEvent: () => navigate('/my/ticket'),
		},
		{
			icon: event,
			label: '대회 기록',
			clickEvent: () => navigate('/my/event/record'),
		},
		{
			icon: exam,
			label: '트라이아웃 필기 시험 기록',
			clickEvent: () => navigate('/my/tryout/record'),
		},
	]
	console.log(getAccount?.data)
	return (
		<>
			<FooterPage>
				<Style.MyInfoDiv>
					<h2>마이페이지</h2>

					<Style.ProfileDiv>
						<img src={getAccount?.data?.profile_img || defaultProfile} />
						<div>
							<Style.NameDiv>
								<div>
									<h2>{getAccount?.data?.name} 님</h2>
									{getAccount?.data?.is_premium && <img src={premium} />}
								</div>
								{getAccount?.data?.is_premium && (
									<p>
										프리미엄 남은 기간 | {getAccount?.data?.remaining_date}일
									</p>
								)}
							</Style.NameDiv>
							<p>{getAccount?.data?.nickname}</p>
							<p>IDX: {getAccount?.data?.idx}</p>
						</div>
					</Style.ProfileDiv>

					<Style.RecordTable>
						<tr>
							<th>프로 자격</th>
							<th>시즌 점수</th>
							<th>티어</th>
						</tr>
						<tr>
							<Style.RecordTd>
								<Style.QualificationList>
									{myInfo?.qualifications?.map((elem) => (
										<p>
											{elem?.manager_name} - {elem?.qualification_name}
										</p>
									))}
								</Style.QualificationList>
							</Style.RecordTd>
							<Style.RecordTd>{myInfo?.score}</Style.RecordTd>
							<Style.RecordTd $tier={myInfo?.tier}>
								<Style.TierWrapper>
									<img
										alt='icon'
										src={myInfo?.tierIcon}
										style={{visibility: isTierIconLoaded ? 'visible' : 'hidden'}}
										onLoad={() => setIsTierIconLoaded(true)}
									/>
									<Style.Tier $tier={myInfo?.tier}>{myInfo?.tier}</Style.Tier>
								</Style.TierWrapper>
							</Style.RecordTd>
						</tr>
					</Style.RecordTable>
				</Style.MyInfoDiv>

				<Style.Content>
					<Style.ElementList>
						<h2>내 정보 수정</h2>
						<Style.List>
							{infoList.map((elem) => (
								<ControlButton
									icon={elem.icon}
									label={elem.label}
									clickEvent={elem.clickEvent}
								/>
							))}
							{/* {!getAccount?.data?.is_premium && <ControlButton icon={premiumData.icon} label={premiumData.label} clickEvent={premiumData.clickEvent} />} */}
						</Style.List>
					</Style.ElementList>

					<Style.ElementList>
						<h2>내 기록</h2>
						<Style.List>
							{recordList.map((elem) => (
								<ControlButton
									icon={elem.icon}
									label={elem.label}
									clickEvent={elem.clickEvent}
								/>
							))}
						</Style.List>
					</Style.ElementList>

					<Style.ControlDiv>
						<DefaultButton caution clickEvent={withdrawEvent}>
							계정 탈퇴하기
						</DefaultButton>
						<DefaultButton clickEvent={logoutEvent}>로그아웃</DefaultButton>
					</Style.ControlDiv>

					<Style.SupportBtn
						onClick={() =>
							(window.location.href = 'https://pf.kakao.com/_KfQBn')
						}
					>
						이용에 어려움이 있으신가요?
					</Style.SupportBtn>
				</Style.Content>
			</FooterPage>

			{isProfileModalShow && (
				<ProfileModal
					profile={getAccount?.data?.profile_img || defaultProfile}
					closeEvent={() => setIsProfileModalShow(false)}
				/>
			)}
			{isNicknameModalShow && (
				<NicknameModal
					name={getAccount?.data?.name}
					nickname={getAccount?.data?.nickname}
					closeEvent={() => setIsNicknameModalShow(false)}
				/>
			)}
			{isContactModalShow && (
				<ContactModal
					international={getAccount?.data?.international_number}
					contact={getAccount?.data?.contact}
					closeEvent={() => setIsContactModalShow(false)}
				/>
			)}
			{isWithdrawModalShow && (
				<WithdrawConfirmModal
					closeEvent={() => setIsWithdrawModalShow(false)}
				/>
			)}
			{isQRModalShow && (
				<QRModal
					isOpen={isQRModalShow}
					closeEvent={() => setIsQRModalShow(false)}
				/>
			)}
		</>
	)
}

export default Mypage
